import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useBenefisCategoryUIContext } from "../BenefisCategoryUIContext";
import { initialFilter } from "../BenefisCategoryUIHelpers";

const prepareFilter = (queryParams, values) => {
  const { searchName } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  //add to Object filter
  filter.name = searchName ?? "";
  newQueryParams.filter = filter;
  return newQueryParams;
};

export const BenefisCategoryFilter = ({ listLoading }) => {
  // BenefisCategory UI Context
  const benefisCategoryUIContext = useBenefisCategoryUIContext();
  const benefisCategoryUIProps = useMemo(() => {
    return {
      setQueryParams: benefisCategoryUIContext.setQueryParams,
      queryParams: benefisCategoryUIContext.queryParams,
      filterType: benefisCategoryUIContext.filterType,
    };
  }, [benefisCategoryUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(
      benefisCategoryUIProps.queryParams,
      values
    );
    if (!isEqual(newQueryParams, benefisCategoryUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      benefisCategoryUIProps.setQueryParams(newQueryParams);
    }
  };

  return (
    <Formik
      initialValues={initialFilter.filter}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-4">
              <input
                type="text"
                className="form-control"
                name="searchName"
                placeholder="Search"
                onBlur={handleBlur}
                value={values.searchName}
                onChange={(e) => {
                  setFieldValue("searchName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Cari</b> Berdasarkan Name
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
